function a(t) {
  return t / (1024 * 1024);
}
const n = (t) => {
  const e = ["Bytes", "KB", "MB", "GB", "TB"];
  if (t === 0)
    return "0 Byte";
  const o = Math.floor(Math.log(t) / Math.log(1024));
  return `${parseFloat((t / Math.pow(1024, o)).toFixed(2))} ${e[o]}`;
};
export {
  n as bytesToHumanReadable,
  a as bytesToMb
};
//# sourceMappingURL=bytes.es.js.map
